/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
// Accessibility: provide names for product gallery thumbnail controls
function labelProductGalleryThumbnails() {
  document.querySelectorAll('.product__thumb__link').forEach((thumbnail, index) => {
    if (!thumbnail.getAttribute('aria-label')) {
      thumbnail.setAttribute('aria-label', `View product image ${index + 1}`);
    }
  });
}

labelProductGalleryThumbnails();

const productGalleryObserver = new MutationObserver(() => {
  labelProductGalleryThumbnails();
});

productGalleryObserver.observe(document.body, {
  childList: true,
  subtree: true
});


/* ===== STATHE — colourway-filtered product gallery · Claude 2026-10-08, DRAFT ONLY =====

   WHAT AL ASKED FOR: on khaite.com the gallery shows only the images of the colour you have
   selected; scrolling does not continue into the other colours. STATHE's gallery already puts the
   selected colour FIRST, then appends every other colour behind it, which is why it runs so long.

   WHY THIS IS IN JAVASCRIPT AND NOT IN LIQUID. The obvious edit is to delete the second loop in
   sections/product.liquid that appends the other colours. Two reasons not to:
     1. Colour switching happens WITHOUT a page reload. The theme swaps which media is shown by
        finding it in the DOM. Delete those images server-side and switching colour would have
        nothing to find — the colour picker would break outright, which is far worse than a long
        gallery.
     2. sections/product.liquid is 68 KB and the API only accepts whole-file replacement, so that
        edit carries real transcription risk for no benefit.
   Hiding instead of deleting keeps every image in the DOM for the theme's own code to find, and
   the page already publishes everything needed to do it: <script data-product-json> carries the
   full product, including each variant's featured_media.

   HOW THE RUNS ARE WORKED OUT — deliberately the same method as the Liquid in product.liquid, so
   the two can never disagree: each colourway's variants point at one "cover" media. Walking
   product.media in order, every image belongs to the last cover seen. That is its run. No
   filename, alt-text or position matching.

   ** BUG FIXED 2026-10-08, same day as written. ** The first version listened for 'variant:change'
   and so never ran on a colour change: the initial filter worked, but switching colour left the
   first colour's images on screen. AL caught it. The theme's real event is 'theme:variant:change'
   — confirmed by reading assets/theme.js, where fireHookEvent dispatches
   new CustomEvent("theme:variant:change", {detail:{variant}, bubbles:true}).
   The wrong name came from the Klaviyo snippet in layout/theme.liquid, which listens for
   'variant:change'. That snippet is therefore almost certainly dead too — worth a separate look,
   since it is what shows the back-in-stock button. Copying a neighbour's assumption instead of
   checking the source is the same mistake that produced the wrong price ratio earlier; the rule
   stands: verify against the thing itself.

   The variant is re-looked-up by id in the product JSON rather than trusting the event's own
   object to carry featured_media, so the data is guaranteed complete whatever the event hands us.

   FAILS OPEN. Every exit path leaves the gallery exactly as it is today. If the JSON is missing,
   unparseable, or the product has fewer than two colourways, nothing is touched; the whole thing
   is wrapped in try/catch for the same reason. A broken filter shows too many images, never none.

   SIDE EFFECT AL SHOULD KNOW: with this on, other colours can only be reached through the colour
   swatch, not by continuing to scroll. That is the Khaite behaviour she asked for. It also makes
   it matter that links INTO a product point at the right colour — a link with no ?variant= lands
   on the default colour and the customer now sees only that one. */
function statheColourwayGallery() {
  const jsonEl = document.querySelector('script[data-product-json]');
  const wrap = document.querySelector('[data-product-slideshow]');
  if (!jsonEl || !wrap) return;

  let product;
  try {
    product = JSON.parse(jsonEl.textContent);
  } catch (e) {
    return;
  }
  if (!product || !Array.isArray(product.media) || !Array.isArray(product.variants)) return;

  // The cover media of each colourway.
  const covers = new Set();
  product.variants.forEach((v) => {
    if (v.featured_media && v.featured_media.id) covers.add(v.featured_media.id);
  });
  // One colourway (or none declared): there is nothing to filter. Leave the page alone.
  if (covers.size < 2) return;

  // Every media item belongs to the last cover seen before it.
  const runOf = new Map();
  let run = null;
  product.media.forEach((m) => {
    if (covers.has(m.id)) run = m.id;
    runOf.set(m.id, run);
  });

  const slides = Array.from(wrap.querySelectorAll('[data-image-id]'));
  if (!slides.length) return;

  function variantById(id) {
    if (!id && id !== 0) return null;
    return product.variants.find((v) => String(v.id) === String(id)) || null;
  }

  function showRunOf(variant) {
    if (!variant) return;
    // Always resolve against the product JSON: the event's variant object is not guaranteed to
    // carry featured_media, while this one always does.
    const full = variantById(variant.id) || variant;
    const cover = full.featured_media && full.featured_media.id;
    if (!cover) return;
    const target = runOf.get(cover);
    if (target === undefined || target === null) return;
    slides.forEach((slide) => {
      const id = Number(slide.getAttribute('data-image-id'));
      slide.classList.toggle('st-run-hidden', runOf.get(id) !== target);
    });
  }

  // Initial state: ?variant= in the URL wins, then the form's hidden input, then the first variant.
  const fromUrl = new URLSearchParams(window.location.search).get('variant');
  const input = document.querySelector('[data-product] input[name="id"]');
  showRunOf(variantById(fromUrl) || variantById(input && input.value) || product.variants[0]);

  // 'theme:variant:change' is the event Broadcast actually fires; it bubbles to document.
  // 'variant:change' is listened for too, harmlessly, in case a future theme version renames it.
  ['theme:variant:change', 'variant:change'].forEach((name) => {
    document.addEventListener(name, (event) => {
      if (event.detail && event.detail.variant) showRunOf(event.detail.variant);
    });
  });
}

try {
  statheColourwayGallery();
} catch (e) {
  /* Fail open: leave the full gallery visible rather than risk hiding everything. */
}
/* ===== end STATHE colourway-filtered product gallery ===== */


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


 